import ApiClient from './apiClient'
import { ZendeskArticle } from '../types/zendeskArticle'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getZendeskArticleList = async (): Promise<any> => ApiClient.get(
  '/api/zendesk_article',
  (result: ZendeskArticle[]) => result,
)
export default getZendeskArticleList
